import moment from "moment";
import { IMlov, IMlovByCategory, IMlovResponse } from "../Zoom/interfaces";
import { getEnvName } from "../constants/Configs";
import { IMeetingErrorData } from "../100-ms-integration/Notifications/interfaces";

export const getDateToMomentISOString = (date?: Date): string => {
  const dateObj = date || new Date();
  return moment(dateObj).toISOString();
};


export const getMlovByCategory = (mlovData: IMlovResponse): IMlovByCategory => {
  const mlovByCategory: IMlovByCategory = {};
  if (mlovData) {
    const mlovList = mlovData?.mlovs || [];
    const mlovCategoryList = mlovData?.mlovCategories || [];
    mlovCategoryList.forEach((singleMlovCategory) => {
      const categoryMlovList = (mlovList || []).filter(mlov => {
        return mlov.categoryId === singleMlovCategory.id;
      })
      mlovByCategory[singleMlovCategory.category] = categoryMlovList;
    });
  }
  return mlovByCategory;
};

export const getMlovListFromCategory = (
  mlovCategoryList: IMlovByCategory,
  categoryName: string,
  returnIsDeleted = false
): IMlov[] => {

  const result = mlovCategoryList[categoryName];

  if (!returnIsDeleted) {
    return result?.filter((mlov) => !mlov.isDeleted);
  }
  return result;
};

export const getMlovIdFromCode = (
  mlovList: IMlov[],
  mlovCode: string
): string => {
  return (mlovList || []).find(mlov => {
    return mlov.code === mlovCode;
  })?.id || '';
};

export const getMlovValueFromId = (
  mlovList: IMlov[],
  mlovId: string
): string => {
  return (mlovList || []).find(mlov => {
    return mlov.id === mlovId;
  })?.value || '';
};

export const getMlovCodeFromId = (
  mlovList: IMlov[],
  mlovId: string
): string => {
  return (mlovList || []).find(mlov => {
    return mlov.id === mlovId;
  })?.code || '';
};
export const isValidObject = (input: any) => {
  return !(input === undefined || input === null);
};

export const capitalizeFirstLetter = (string: string) => {
  string = string.toLowerCase();
  return string === ''
    ? string
    : string.charAt(0).toUpperCase() + string.slice(1);
};

export const isMobile = () =>
  navigator.userAgent && navigator.userAgent.toLowerCase().includes("mobile");

export const isDesktopMode = () => {
  return window.innerWidth > window.screen.availWidth;
};

export const isValidJsonString = (jsonString: string) => {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    return false;
  }
};

export const getMeetingErrorData = (data: any) => {
  let description = '';
  let title = 'Init Error';
  if (data?.description?.includes('role is invalid')) {
    description =
      'This role does not exist for the given room. Try again with a valid role.';
    title = 'Invalid Role';
  } else if (data?.description?.includes('room is not active')) {
    description =
      'This room is not active. Try again with a valid meeting link.';
    title = 'Init Error';
  } else {
    const isValidJson = isValidJsonString(data?.description);
    if (isValidJson) {
      const errorData = JSON.parse(data?.description);
      description = errorData?.message || data.description;
    } else {
      description = data.description;
    }
    title = 'Init Error';
  }
  return {
    description,
    title
  } as IMeetingErrorData;
}